if (!customElements.get("wlsn-product-upsell")) {
    class WLSNProductUpsell extends HTMLElement {
      constructor() {
        super();
        this.drawer = document.querySelector("wlsn-cart-drawer");
        this.isLoading = false;
      }
  
      connectedCallback() {
        this.buttons = this.querySelectorAll(".js-wlsn-upsell-add-to-cart");
        this.bindEvents();
      }
  
      bindEvents() {
        if (!this.buttons.length) return;
  
        this.buttons.forEach((button) => {
          button.addEventListener("click", () =>
            this.handleAddToCart(button)
          );
        });
      }
  
      async handleAddToCart(button) {
        if (this.isLoading) return;
  
        const ids = button.dataset.productId?.split(",");
        const sellingPlanId = button.dataset.sellingPlanId;
        const quantity = 1;
  
        if (!ids || !ids.length) return;
  
        this.isLoading = true;
        this.setButtonState(button, "loading");
  
        const bundleId = `upsell_${Date.now()}`;
  
        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              items: ids.map((id) => ({
                id: id.trim(),
                quantity: quantity,
                selling_plan: sellingPlanId || undefined,
                properties: {
                  _bundle_id: bundleId
                }
              })),
            }),
          });
  
          if (!response.ok) throw new Error("Add to cart failed");
  
          if (this.drawer) {
            await this.drawer.refreshDrawer();
            this.drawer.openDrawer();
          }
  
          this.setButtonState(button, "success");
  
        } catch (error) {
          console.error("Upsell error:", error);
          this.setButtonState(button, "default");
        } finally {
          this.isLoading = false;
        }
      }
  
      setButtonState(button, state) {
        const originalText =
          button.dataset.originalText || button.innerHTML;
  
        if (!button.dataset.originalText) {
          button.dataset.originalText = originalText;
        }
  
        if (state === "loading") {
          button.disabled = true;
          button.classList.add("is-loading");
          button.innerHTML = "Adding...";
        }
  
        if (state === "success") {
          button.innerHTML = "✓ Added";
          button.classList.remove("is-loading");
  
          setTimeout(() => {
            button.innerHTML = button.dataset.originalText;
            button.disabled = false;
          }, 2000);
        }
  
        if (state === "default") {
          button.innerHTML = button.dataset.originalText;
          button.disabled = false;
          button.classList.remove("is-loading");
        }
      }
    }
  
    customElements.define("wlsn-product-upsell", WLSNProductUpsell);
  }